import Bug from './bug';
import Companion from './companion';

export { Bug, Companion };
